<div class="container" #container>
    <!-- Small - White -->
    <svg preserveAspectRatio="xMidYMid" style="margin:auto;background:0 0;display:block;shape-rendering:auto"
         viewBox="0 0 33.333333333333336 33.333333333333336" width="50px" height="50px"
         *ngIf="size === 0 && color === 0">
        <g transform="translate(-8.333333333333334,-8.333333333333334)">
            <circle fill="color" r="5" cx="37.5" cy="25">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.9s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.9s" />
            </circle>
            <circle fill="color" r="5" cx="35.112712429686844" cy="32.34731565365591">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.8s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.8s" />
            </circle>
            <circle fill="color" r="5" cx="28.862712429686844" cy="36.88820645368942">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.7s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.7s" />
            </circle>
            <circle fill="color" r="5" cx="21.13728757031316" cy="36.88820645368942">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.6s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.6s" />
            </circle>
            <circle fill="color" r="5" cx="14.887287570313159" cy="32.34731565365591">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.5s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.5s" />
            </circle>
            <circle fill="color" r="5" cx="12.5" cy="25">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.4s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.4s" />
            </circle>
            <circle fill="color" r="5" cx="14.887287570313156" cy="17.65268434634409">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.3s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.3s" />
            </circle>
            <circle fill="color" r="5" cx="21.137287570313156" cy="13.111793546310581">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.2s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.2s" />
            </circle>
            <circle fill="color" r="5" cx="28.86271242968684" cy="13.11179354631058">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.1s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.1s" />
            </circle>
            <circle fill="color" r="5" cx="35.11271242968684" cy="17.65268434634408">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="0s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="0s" />
            </circle>
        </g>
    </svg>

    <!-- Medium - White -->
    <svg preserveAspectRatio="xMidYMid" style="margin:auto;background:0 0;display:block;shape-rendering:auto"
         viewBox="0 0 50 50" width="75px" height="75px" *ngIf="size === 1 && color === 0">
        <g transform="translate(-12.5,-12.5)">
            <circle fill="color" r="5" cx="56.25" cy="37.5">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.9166666666666666s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.9166666666666666s" />
            </circle>
            <circle fill="color" r="5" cx="53.737976320958225" cy="46.875">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.8333333333333334s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.8333333333333334s" />
            </circle>
            <circle fill="color" r="5" cx="46.875" cy="53.737976320958225">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.75s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.75s" />
            </circle>
            <circle fill="color" r="5" cx="37.5" cy="56.25">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.6666666666666666s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.6666666666666666s" />
            </circle>
            <circle fill="color" r="5" cx="28.125000000000004" cy="53.737976320958225">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.5833333333333334s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.5833333333333334s" />
            </circle>
            <circle fill="color" r="5" cx="21.26202367904178" cy="46.87500000000001">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.5s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.5s" />
            </circle>
            <circle fill="color" r="5" cx="18.75" cy="37.5">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.4166666666666667s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.4166666666666667s" />
            </circle>
            <circle fill="color" r="5" cx="21.26202367904177" cy="28.125000000000007">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.3333333333333333s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.3333333333333333s" />
            </circle>
            <circle fill="color" r="5" cx="28.124999999999993" cy="21.262023679041782">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.25s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.25s" />
            </circle>
            <circle fill="color" r="5" cx="37.5" cy="18.75">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.16666666666666666s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.16666666666666666s" />
            </circle>
            <circle fill="color" r="5" cx="46.874999999999986" cy="21.262023679041768">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.08333333333333333s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.08333333333333333s" />
            </circle>
            <circle fill="color" r="5" cx="53.73797632095822" cy="28.124999999999993">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="0s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="0s" />
            </circle>
        </g>
    </svg>

    <!-- Large - White  -->
    <svg preserveAspectRatio="xMidYMid" style="margin:auto;background:0 0;display:block;shape-rendering:auto"
         viewBox="0 0 66.66666666666667 66.66666666666667" width="100px" height="100px"
         *ngIf="size === 2 && color === 0">
        <g transform="translate(-16.666666666666668,-16.666666666666668)">
            <circle fill="color" r="5" cx="75" cy="50">
                <animate attributeName="r" repeatCount="indefinite" values="2;4;5;4;2" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.9166666666666666s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.9166666666666666s" />
            </circle>
            <circle fill="color" r="5" cx="71.65063509461098" cy="62.5">
                <animate attributeName="r" repeatCount="indefinite" values="2;4;5;4;2" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.8333333333333334s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.8333333333333334s" />
            </circle>
            <circle fill="color" r="5" cx="62.5" cy="71.65063509461096">
                <animate attributeName="r" repeatCount="indefinite" values="2;4;5;4;2" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.75s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.75s" />
            </circle>
            <circle fill="color" r="5" cx="50" cy="75">
                <animate attributeName="r" repeatCount="indefinite" values="2;4;5;4;2" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.6666666666666666s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.6666666666666666s" />
            </circle>
            <circle fill="color" r="5" cx="37.50000000000001" cy="71.65063509461098">
                <animate attributeName="r" repeatCount="indefinite" values="2;4;5;4;2" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.5833333333333334s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.5833333333333334s" />
            </circle>
            <circle fill="color" r="5" cx="28.349364905389038" cy="62.50000000000001">
                <animate attributeName="r" repeatCount="indefinite" values="2;4;5;4;2" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.5s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.5s" />
            </circle>
            <circle fill="color" r="5" cx="25" cy="50">
                <animate attributeName="r" repeatCount="indefinite" values="2;4;5;4;2" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.4166666666666667s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.4166666666666667s" />
            </circle>
            <circle fill="color" r="5" cx="28.34936490538903" cy="37.50000000000001">
                <animate attributeName="r" repeatCount="indefinite" values="2;4;5;4;2" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.3333333333333333s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.3333333333333333s" />
            </circle>
            <circle fill="color" r="5" cx="37.499999999999986" cy="28.34936490538904">
                <animate attributeName="r" repeatCount="indefinite" values="2;4;5;4;2" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.25s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.25s" />
            </circle>
            <circle fill="color" r="5" cx="49.99999999999999" cy="25">
                <animate attributeName="r" repeatCount="indefinite" values="2;4;5;4;2" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.16666666666666666s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.16666666666666666s" />
            </circle>
            <circle fill="color" r="5" cx="62.499999999999986" cy="28.349364905389024">
                <animate attributeName="r" repeatCount="indefinite" values="2;4;5;4;2" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.08333333333333333s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.08333333333333333s" />
            </circle>
            <circle fill="color" r="5" cx="71.65063509461096" cy="37.499999999999986">
                <animate attributeName="r" repeatCount="indefinite" values="2;4;5;4;2" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="0s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#ffffff;#ffffff;#ffffff;#ffffff;#ffffff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="0s" />
            </circle>
        </g>
    </svg>

    <!-- Small - Blue -->
    <svg preserveAspectRatio="xMidYMid" style="margin:auto;background:0 0;display:block;shape-rendering:auto"
         viewBox="0 0 33.333333333333336 33.333333333333336" width="50px" height="50px"
         *ngIf="size === 0 && color === 1">
        <g transform="translate(-8.333333333333334,-8.333333333333334)">
            <circle fill="color" r="5" cx="37.5" cy="25">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.9s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.9s" />
            </circle>
            <circle fill="color" r="5" cx="35.112712429686844" cy="32.34731565365591">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.8s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.8s" />
            </circle>
            <circle fill="color" r="5" cx="28.862712429686844" cy="36.88820645368942">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.7s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.7s" />
            </circle>
            <circle fill="color" r="5" cx="21.13728757031316" cy="36.88820645368942">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.6s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.6s" />
            </circle>
            <circle fill="color" r="5" cx="14.887287570313159" cy="32.34731565365591">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.5s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.5s" />
            </circle>
            <circle fill="color" r="5" cx="12.5" cy="25">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.4s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.4s" />
            </circle>
            <circle fill="color" r="5" cx="14.887287570313156" cy="17.65268434634409">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.3s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.3s" />
            </circle>
            <circle fill="color" r="5" cx="21.137287570313156" cy="13.111793546310581">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.2s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.2s" />
            </circle>
            <circle fill="color" r="5" cx="28.86271242968684" cy="13.11179354631058">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.1s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.1s" />
            </circle>
            <circle fill="color" r="5" cx="35.11271242968684" cy="17.65268434634408">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="0s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="0s" />
            </circle>
        </g>
    </svg>

    <!-- Medium - Blue -->
    <svg preserveAspectRatio="xMidYMid" style="margin:auto;background:0 0;display:block;shape-rendering:auto"
         viewBox="0 0 50 50" width="75px" height="75px" *ngIf="size === 1 && color === 1">
        <g transform="translate(-12.5,-12.5)">
            <circle fill="color" r="5" cx="56.25" cy="37.5">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.9166666666666666s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.9166666666666666s" />
            </circle>
            <circle fill="color" r="5" cx="53.737976320958225" cy="46.875">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.8333333333333334s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.8333333333333334s" />
            </circle>
            <circle fill="color" r="5" cx="46.875" cy="53.737976320958225">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.75s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.75s" />
            </circle>
            <circle fill="color" r="5" cx="37.5" cy="56.25">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.6666666666666666s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.6666666666666666s" />
            </circle>
            <circle fill="color" r="5" cx="28.125000000000004" cy="53.737976320958225">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.5833333333333334s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.5833333333333334s" />
            </circle>
            <circle fill="color" r="5" cx="21.26202367904178" cy="46.87500000000001">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.5s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.5s" />
            </circle>
            <circle fill="color" r="5" cx="18.75" cy="37.5">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.4166666666666667s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.4166666666666667s" />
            </circle>
            <circle fill="color" r="5" cx="21.26202367904177" cy="28.125000000000007">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.3333333333333333s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.3333333333333333s" />
            </circle>
            <circle fill="color" r="5" cx="28.124999999999993" cy="21.262023679041782">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.25s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.25s" />
            </circle>
            <circle fill="color" r="5" cx="37.5" cy="18.75">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.16666666666666666s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.16666666666666666s" />
            </circle>
            <circle fill="color" r="5" cx="46.874999999999986" cy="21.262023679041768">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.08333333333333333s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.08333333333333333s" />
            </circle>
            <circle fill="color" r="5" cx="53.73797632095822" cy="28.124999999999993">
                <animate attributeName="r" repeatCount="indefinite" values="1;2;3;2;1" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="0s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="0s" />
            </circle>
        </g>
    </svg>

    <!-- Large - Blue -->
    <svg preserveAspectRatio="xMidYMid" style="margin:auto;background:0 0;display:block;shape-rendering:auto"
         viewBox="0 0 66.66666666666667 66.66666666666667" width="100px" height="100px"
         *ngIf="size === 2 && color === 1">
        <g transform="translate(-16.666666666666668,-16.666666666666668)">
            <circle fill="color" r="5" cx="75" cy="50">
                <animate attributeName="r" repeatCount="indefinite" values="2;4;5;4;2" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.9166666666666666s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.9166666666666666s" />
            </circle>
            <circle fill="color" r="5" cx="71.65063509461098" cy="62.5">
                <animate attributeName="r" repeatCount="indefinite" values="2;4;5;4;2" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.8333333333333334s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.8333333333333334s" />
            </circle>
            <circle fill="color" r="5" cx="62.5" cy="71.65063509461096">
                <animate attributeName="r" repeatCount="indefinite" values="2;4;5;4;2" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.75s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.75s" />
            </circle>
            <circle fill="color" r="5" cx="50" cy="75">
                <animate attributeName="r" repeatCount="indefinite" values="2;4;5;4;2" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.6666666666666666s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.6666666666666666s" />
            </circle>
            <circle fill="color" r="5" cx="37.50000000000001" cy="71.65063509461098">
                <animate attributeName="r" repeatCount="indefinite" values="2;4;5;4;2" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.5833333333333334s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.5833333333333334s" />
            </circle>
            <circle fill="color" r="5" cx="28.349364905389038" cy="62.50000000000001">
                <animate attributeName="r" repeatCount="indefinite" values="2;4;5;4;2" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.5s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.5s" />
            </circle>
            <circle fill="color" r="5" cx="25" cy="50">
                <animate attributeName="r" repeatCount="indefinite" values="2;4;5;4;2" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.4166666666666667s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.4166666666666667s" />
            </circle>
            <circle fill="color" r="5" cx="28.34936490538903" cy="37.50000000000001">
                <animate attributeName="r" repeatCount="indefinite" values="2;4;5;4;2" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.3333333333333333s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.3333333333333333s" />
            </circle>
            <circle fill="color" r="5" cx="37.499999999999986" cy="28.34936490538904">
                <animate attributeName="r" repeatCount="indefinite" values="2;4;5;4;2" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.25s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.25s" />
            </circle>
            <circle fill="color" r="5" cx="49.99999999999999" cy="25">
                <animate attributeName="r" repeatCount="indefinite" values="2;4;5;4;2" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.16666666666666666s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.16666666666666666s" />
            </circle>
            <circle fill="color" r="5" cx="62.499999999999986" cy="28.349364905389024">
                <animate attributeName="r" repeatCount="indefinite" values="2;4;5;4;2" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="-0.08333333333333333s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="-0.08333333333333333s" />
            </circle>
            <circle fill="color" r="5" cx="71.65063509461096" cy="37.499999999999986">
                <animate attributeName="r" repeatCount="indefinite" values="2;4;5;4;2" times="0;0.1;0.2;0.3;1"
                         dur="0.75s" begin="0s" />
                <animate attributeName="fill" repeatCount="indefinite" values="#3378ff;#3378ff;#0057ff;#3378ff;#3378ff"
                         times="0;0.1;0.2;0.3;1" dur="0.75s" begin="0s" />
            </circle>
        </g>
    </svg>
</div>
